import React, { useEffect, useState } from 'react';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';

import AboutData from './AboutData';
import FaqData from './FaqData';
import PolicyCostData from './PolicyCostData';
import PurchasingProcessData from './PurchasingProcessData';
import ProductData from './ProductData';
import BusinessSolutionsArticleData from './BusinessSolutionsArticleData';
import BusinessSolutionsDetailArticleData from './BusinessSolutionsDetailArticleData';
import StatisticsData from './StatisticsData';

export default function BusinessSolutionsData(props) {
  const [primaryBrandColor, setPrimaryBrandColor] = useState(null);
  const [availableProductJourneys, setAvailableProductJourneys] = useState({});
  
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  const accountProductTypeSettings = accountObj.accountProducts.find(product => product.productLandingUrl === props.history.location.pathname);
  const accountLandingOverride = accountObj.accountOverrides && accountProductTypeSettings ?
    accountObj.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;

  const checkProducts = () => {
    const term3 = accountObj.accountProducts.some(product => product.productLandingUrl === "/landing/term-insurance");
    const term2 = accountObj.accountProducts.some(product => product.productLandingUrl === "/landing/term");
    const americo3 = accountObj.accountProducts.some(product => product.productLandingUrl === "/landing/loan-protection");
    const americo2 = accountObj.accountProducts.some(product => product.productLandingUrl === "/landing/loan-protector" || product.productLandingUrl === "/quote/term-life-insurance/loan-protector");

    const journeys = {
      americoJourney: americo3 ? "/landing/loan-protection" : americo2 ? "/landing/loan-protector" : "/",
      termJourney: term3 ? "/landing/term-insurance" : term2 ? "/landing/term" :  "/"
    }

    setAvailableProductJourneys(journeys);
  }
  
  useEffect(() => {
    if (!accountObj.accountOverrides) {
      setPrimaryBrandColor(accountObj.account.primaryColor);
    } else {
      setPrimaryBrandColor(accountObj.accountOverrides.primaryColor);
    }
    checkProducts();
  }, []);

  const defaultValueProposition = [{
    title: "Business Life Insurance Simplified.",
    subtitle: "Solving your business challenges",
  },
  {
    title: "Business Life Insurance Simplified.",
    subtitle: "Mitigating your unforeseen business risks",
  },
  {
    title: "Business Life Insurance Simplified.",
    subtitle: "Ensuring your business continuity",
  }];

  return {
    name: 'Business Solutions',
    subtitle: 'Replace',
    footerMessage: "Get business insurance from start to finish completely online",
    footerButtonName: "See Rate",
    heroText: accountLandingOverride ? JSON.parse(accountLandingOverride.valueProposition) : defaultValueProposition,
    about: AboutData(null, null, null, null),
    purchasingProcess: PurchasingProcessData(),
    policyCost: PolicyCostData(),
    faq: FaqData(),
    termArticle: BusinessSolutionsArticleData(),
    termDetailArticle: BusinessSolutionsDetailArticleData(),
    statistics: StatisticsData(),
    productData: ProductData(),
    availableProductJourneys: availableProductJourneys,
    isAddDefaultFaq: false,
    hideCommonFaq: true,
  };
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/BusinessSolutions/BusinessSolutionsData.js